import '.ej{background:rgba(0,0,0,0.3);}.ssr-plugin'
import '.bh{position:fixed;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.bi{inset:0px;}.ssr-plugin'
import '.e1{z-index:1;}.ssr-plugin'
import '.ek{padding:1rem;}.ssr-plugin'
import '.ag{border-radius:16px;}.ssr-plugin'
import '.e2{max-width:600px;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.e5{max-height:720px;}.ssr-plugin'
import '.o{height:100%;}.ssr-plugin'
import '.n{position:relative;}.ssr-plugin'
import '.bj{overflow:hidden;}.ssr-plugin'
import '.ae{justify-content:space-between;}.ssr-plugin'
import '.c6{overflow-y:scroll;}.ssr-plugin'
import '.el{width:36px;}.ssr-plugin'
import '.em{height:196px;}.ssr-plugin'
import '.p{position:absolute;}.ssr-plugin'
import '.z{bottom:0px;}.ssr-plugin'
import '.dp{left:0px;}.ssr-plugin'
import '.dr{right:0px;}.ssr-plugin'
import '.b2{gap:16px;}.ssr-plugin'
import { useEffect } from 'react'
import { styled } from 'inlines'
import { Text } from './Text'
import { Html } from './Html'
import { CloseButton } from './CloseButton'
import { useTheme } from '../providers/useTheme'
import { useIsMobile } from '../hooks/useIsMobile'
import { VoteButton } from './VoteButton'
import { Canva } from './Canva'

export const BioModal = ({
  bio,
  label,
  image,
  ddi,
  description,
  setOpenBioModal,
  isInverted,
  maxVotes,
  votes,
  handleVoteChange,
}) => {
  const { colors } = useTheme()
  const isMobile = useIsMobile()

  useEffect(() => {
    const originalOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = originalOverflow
    }
  }, [])

  return (
    <div className="ej bh a d c bi e1 ek"
      onClick={() => setOpenBioModal(false)}
    >
      <div className="ag e2 h e5 o n bj"
        style={{
          backgroundColor: colors.background,}}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="a h d ae"
          style={{
            padding: isMobile ? '32px 16px' : '32px 24px',
          }}
        >
          <Text variant="title" style={{ fontSize: 24 }}>
            {label}
          </Text>
          <CloseButton
            color={colors.textPrimary}
            onClick={() => setOpenBioModal(false)}
          />
        </div>
        <div className="c6 o"
          style={{
            paddingLeft: isMobile ? 16 : 24,
            paddingRight: isMobile ? 16 : 24,}}
        >
          {bio?.bio && (
            <Text
              variant="heading"
              style={{ marginBottom: 24 }}
              color={colors.textPrimary}
            >
              {bio?.about}
            </Text>
          )}
          <Html color={colors.textSecondary} variant="display-regular">
            {bio?.bio as string}
          </Html>
          {bio?.lyrics && (
            <Text
              variant="heading"
              style={{ marginTop: 32, marginBottom: 24 }}
              color={colors.textPrimary}
            >
              {bio?.lyricsTitle}
            </Text>
          )}
          <Html color={colors.textSecondary} variant="display-regular">
            {bio?.lyrics as string}
          </Html>
          <div className="el em" />
        </div>

        <div className="a h ae d p z dp dr b2"
          style={{
            backgroundColor: colors.background,
            padding: isMobile ? '24px 16px' : 24,
            borderTop: `1px solid ${colors.border}`,}}
        >
          <div className="b2 d"
            style={{
              display: isMobile ? 'block' : 'flex',
              maxWidth: isMobile ? '60%' : '100%',
            }}
          >
            <Canva
              src={image}
              size={{
                width: 44,
                height: 44,
              }}
              ddi={ddi}
              style={{
                display: isMobile ? 'none' : 'block',
                borderRadius: '6px',
                '& *': {
                  borderRadius: '6px',
                  border: 'none',
                },
              }}
            />
            <styled.div>
              <Text
                color={colors.textPrimary}
                variant="display-medium"
                style={{ fontWeight: 600, wordBreak: 'break-word' }}
              >
                <span style={{ color: colors.primaryAccent }}>{ddi} • </span>
                {label}
              </Text>
              <Text
                variant="display-regular"
                color={colors.textSecondary}
                style={{ fontSize: 14 }}
              >
                {description}
              </Text>
            </styled.div>
          </div>
          <div style={{ paddingLeft: 12 }}>
            <VoteButton
              isInverted={isInverted}
              maxVotes={maxVotes}
              votes={votes}
              on={{
                change: handleVoteChange,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
